import TAnchor from './anchor.vue'
import TAnchorLink from './anchor-link.vue'

TAnchor.Item = TAnchorLink

TAnchor.install = Vue => {
  Vue.component(TAnchor.name, TAnchor)
}

TAnchorLink.install = Vue => {
  Vue.component(TAnchorLink.name, TAnchorLink)
}

export {
  TAnchor,
  TAnchorLink
}



// WEBPACK FOOTER //
// ./src/module/anchor/index.js